import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "container-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "row-title-container" }
const _hoisted_4 = { class: "page-header-left" }
const _hoisted_5 = { class: "page-title" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  key: 0,
  class: "header-right-container"
}
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "page-content" }

import { VIconSvg, VMessage } from "@/components";
import { computed, onMounted, ref, useSlots } from "vue";
import { EventBus } from "@/plugins/event-bus";
import { TranslateResult } from "vue-i18n";
import { isExistSlot } from "@/plugins/helpers";

interface Props {
  title?: string | TranslateResult;
  maxWidth?: string;
  backRoute?: object;
  pageMessage?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VContainerPage',
  props: {
    title: { default: "" },
    maxWidth: { default: "full" },
    backRoute: { default: () => ({}) },
    pageMessage: { default: "" }
  },
  emits: ["closeMessage"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const contentWrapper = ref();

const slots = useSlots();
let isShownContent = ref(false);

onMounted(() => {
  isShownContent.value = true;

  contentWrapper.value.addEventListener("scroll", (event) =>
    EventBus.$emit("containerPageScroll", event)
  );
});

const maxWidthClasses = computed(() => {
  return {
    "max-width-xga": props.maxWidth === "xga",
    "max-width-xgap": props.maxWidth === "xgap",
    "max-width-hd": props.maxWidth === "hd",
    "max-width-hdp": props.maxWidth === "hdp",
    "max-width-fhd": props.maxWidth === "fhd",
    "max-width-qhd": props.maxWidth === "qhd",
    "max-width-full": props.maxWidth === "full",
  };
});

const isShownMessage = computed(() => props.pageMessage);

const subTitleClasses = computed(() => {
  return { "subtitle-with-icon": !!slots["title-icon"] };
});

const showSubTitle = computed(() => {
  return isExistSlot("sub-title", slots) || !!Object.keys(props.backRoute).length;
});

const closeMessage = () => {
  emit("closeMessage");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "contentWrapper",
          ref: contentWrapper,
          class: "content-wrapper"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["width-container", maxWidthClasses.value])
          }, [
            (isShownMessage.value)
              ? (_openBlock(), _createBlock(_unref(VMessage), {
                  key: 0,
                  text: _ctx.pageMessage,
                  closable: "",
                  onCloseMessage: closeMessage
                }, null, 8, ["text"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _renderSlot(_ctx.$slots, "title-icon"),
                      _createElementVNode("h1", null, [
                        _renderSlot(_ctx.$slots, "title", {}, () => [
                          _createTextVNode(_toDisplayString(_ctx.title), 1)
                        ])
                      ])
                    ]),
                    _renderSlot(_ctx.$slots, "title-right")
                  ])
                ]),
                (_unref(isExistSlot)('header-right', _unref(slots)))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _renderSlot(_ctx.$slots, "header-right")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (showSubTitle.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["sub-title-container", subTitleClasses.value])
                  }, [
                    _renderSlot(_ctx.$slots, "sub-title", {}, () => [
                      _createVNode(_component_router_link, {
                        to: _ctx.backRoute,
                        "data-cy": "back-route-link",
                        class: "link"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(VIconSvg), {
                            name: "ArrowheadLeft",
                            size: "2xs",
                            color: "fc-accent",
                            "color-tag": "fill"
                          }),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.backRoute.title), 1)
                        ], undefined, true),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ], 2)
        ], 512)
      ], 512), [
        [_vShow, _unref(isShownContent)]
      ])
    ], undefined, true),
    _: 3
  }))
}
}

})